/**
 * Compre Junto: total do bundle + wizard sequencial de variantes (modal 1→2→N) e ATC no último passo.
 */
(function () {
  const CART_UPDATE = 'cart:update';
  const VARIANT_UPDATE = 'variant:update';

  function getSectionRoot(container) {
    return container.closest('[data-compre-junto]');
  }

  function formatMoney(cents, currencySymbol) {
    if (cents == null || isNaN(cents)) return currencySymbol + '0,00';
    const value = (cents / 100).toFixed(2);
    const [intPart, decPart] = value.split('.');
    const withDots = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (currencySymbol || '') + withDots + ',' + decPart;
  }

  function getSelectedVariantIdFromCard(cardWrapper) {
    const productCard = cardWrapper.querySelector('product-card');
    if (productCard && typeof productCard.getSelectedVariantId === 'function') {
      const id = productCard.getSelectedVariantId();
      if (id) return id;
    }
    const checked = cardWrapper.querySelector('input[type="radio"]:checked[data-variant-id]');
    if (checked && checked.dataset.variantId) return checked.dataset.variantId;
    return cardWrapper.dataset.initialVariantId || null;
  }

  function updateTotal(sectionRoot) {
    const totalEl = sectionRoot.querySelector('[data-compre-junto-total]');
    const cards = sectionRoot.querySelectorAll('[data-compre-junto-card]');
    const symbol = sectionRoot.dataset.currencySymbol || '';
    let totalCents = 0;

    cards.forEach((wrapper) => {
      const initialPrice = wrapper.dataset.initialPrice;
      let cents = initialPrice ? parseInt(initialPrice, 10) : 0;
      if (isNaN(cents)) cents = 0;

      const priceEl = wrapper.querySelector(
        'product-price .price, [ref="priceContainer"] .price, .product-card__content .price'
      );
      if (priceEl && priceEl.textContent) {
        const priceText = priceEl.textContent.trim().replace(/\s+/g, '');
        const brFormat = priceText.match(/([\d.,]+)/);
        if (brFormat) {
          const numStr = brFormat[1].replace(/\./g, '').replace(',', '.');
          const value = parseFloat(numStr);
          if (!isNaN(value)) cents = Math.round(value * 100);
        }
      }

      if (cents > 0) totalCents += cents;
    });

    if (totalEl) totalEl.textContent = formatMoney(totalCents, symbol);
  }

  function setupVariantListeners(sectionRoot) {
    sectionRoot.querySelectorAll('[data-compre-junto-card]').forEach((wrapper) => {
      const card = wrapper.querySelector('product-card');
      if (card) {
        card.addEventListener(VARIANT_UPDATE, () => updateTotal(sectionRoot));
      }
    });
  }

  function parseVariantsJson(step) {
    const script = step.querySelector('[data-compre-junto-wizard-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptions(step) {
    const options = {};
    step.querySelectorAll('.compre-junto-wizard__fieldset').forEach((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!(checked instanceof HTMLInputElement)) return;
      const position = checked.dataset.optionPosition || '1';
      options[`option${position}`] = checked.value;
    });
    return options;
  }

  function resolveVariant(step) {
    const variants = parseVariantsJson(step);
    if (!variants.length) return null;

    const fieldsets = step.querySelectorAll('.compre-junto-wizard__fieldset');
    if (!fieldsets.length) {
      return variants.find((v) => v.available) || variants[0] || null;
    }

    for (const fieldset of fieldsets) {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!(checked instanceof HTMLInputElement)) return null;
      if (checked.dataset.optionAvailable === 'false') return null;
    }

    const selected = getSelectedOptions(step);
    return (
      variants.find((variant) => {
        const o1 = selected.option1 == null || variant.option1 === selected.option1;
        const o2 = selected.option2 == null || variant.option2 === selected.option2;
        const o3 = selected.option3 == null || variant.option3 === selected.option3;
        return o1 && o2 && o3 && variant.available;
      }) || null
    );
  }

  function showStepError(step, visible) {
    const error = step.querySelector('[data-compre-junto-wizard-error]');
    if (!error) return;
    error.classList.toggle('is-visible', Boolean(visible));
  }

  function updateStepUi(step, variant) {
    const imageEl = step.querySelector('[data-compre-junto-wizard-image]');
    if (imageEl instanceof HTMLImageElement) {
      if (variant && variant.image) {
        imageEl.src = variant.image;
      } else if (imageEl.dataset.defaultSrc) {
        imageEl.src = imageEl.dataset.defaultSrc;
      }
    }
  }

  function getWizardHost(sectionRoot) {
    return sectionRoot.querySelector('[data-compre-junto-wizard]');
  }

  function getSteps(wizardHost) {
    return Array.from(wizardHost.querySelectorAll('[data-compre-junto-wizard-step]'));
  }

  function setActiveStep(wizardHost, index) {
    const steps = getSteps(wizardHost);
    const progress = wizardHost.querySelector('[data-compre-junto-wizard-progress]');
    steps.forEach((step, i) => {
      const active = i === index;
      step.classList.toggle('is-active', active);
      if (active) {
        step.removeAttribute('hidden');
      } else {
        step.setAttribute('hidden', '');
      }
      showStepError(step, false);
    });
    if (progress) {
      progress.textContent = `Produto ${index + 1} de ${steps.length}`;
    }
    wizardHost.dataset.activeStep = String(index);

    const activeStep = steps[index];
    if (activeStep) {
      const focusTarget =
        activeStep.querySelector('[data-compre-junto-wizard-next], [data-compre-junto-wizard-add]') ||
        activeStep.querySelector('input:not([disabled])') ||
        activeStep;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        requestAnimationFrame(() => focusTarget.focus());
      }
    }
  }

  function openWizard(sectionRoot) {
    const wizardHost = getWizardHost(sectionRoot);
    if (!wizardHost) return false;
    const steps = getSteps(wizardHost);
    if (!steps.length) return false;

    sectionRoot.__compreJuntoSelections = {};
    setActiveStep(wizardHost, 0);

    if (typeof wizardHost.showDialog === 'function') {
      wizardHost.showDialog();
    } else {
      const dialog = wizardHost.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }
    return true;
  }

  function closeWizard(wizardHost) {
    if (!wizardHost) return;
    if (typeof wizardHost.closeDialog === 'function') {
      wizardHost.closeDialog();
      return;
    }
    const dialog = wizardHost.querySelector('dialog');
    if (dialog && dialog.open) dialog.close();
  }

  async function addItemsToCart(sectionRoot, items, button) {
    if (!items.length) return;

    const cartAddUrl =
      (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

    const labelEl = button ? button.querySelector('.compre-junto-wizard__btn-label') : null;
    const originalText = labelEl ? labelEl.textContent : button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      if (labelEl) labelEl.textContent = 'Adicionando…';
      else button.textContent = 'Adicionando…';
    }

    try {
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok && !data.status) {
        document.dispatchEvent(
          new CustomEvent(CART_UPDATE, {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: sectionRoot.dataset.sectionId || '',
              data: { source: 'compre-junto', itemCount: data.item_count },
            },
          })
        );
        closeWizard(getWizardHost(sectionRoot));
      } else {
        const message = data.message || data.description || 'Não foi possível adicionar ao carrinho.';
        if (typeof window.alert === 'function') window.alert(message);
      }
    } finally {
      if (button) {
        button.disabled = false;
        if (labelEl) labelEl.textContent = originalText;
        else button.textContent = originalText;
      }
    }
  }

  function collectAllSelections(sectionRoot, wizardHost) {
    const selections = sectionRoot.__compreJuntoSelections || {};
    const steps = getSteps(wizardHost);
    const items = [];

    for (const step of steps) {
      const productId = step.dataset.productId;
      let variantId = selections[productId];

      if (!variantId) {
        const resolved = resolveVariant(step);
        if (resolved && resolved.id) variantId = resolved.id;
      }

      if (!variantId) return null;
      items.push({ id: Number(variantId), quantity: 1 });
    }

    return items;
  }

  function storeCurrentSelection(sectionRoot, step) {
    const variant = resolveVariant(step);
    if (!variant || !variant.id) {
      showStepError(step, true);
      return false;
    }
    showStepError(step, false);
    if (!sectionRoot.__compreJuntoSelections) sectionRoot.__compreJuntoSelections = {};
    sectionRoot.__compreJuntoSelections[step.dataset.productId] = variant.id;
    updateStepUi(step, variant);
    return true;
  }

  function bindWizard(sectionRoot) {
    const wizardHost = getWizardHost(sectionRoot);
    if (!wizardHost || wizardHost.dataset.wizardBound === 'true') return;
    wizardHost.dataset.wizardBound = 'true';

    wizardHost.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      const step = target.closest('[data-compre-junto-wizard-step]');
      if (!step || !wizardHost.contains(step)) return;

      const fieldset = target.closest('.compre-junto-wizard__fieldset--swatches');
      if (fieldset) {
        const swatchLabel = fieldset.querySelector('[data-compre-junto-wizard-swatch-label]');
        if (swatchLabel && target.dataset.optionLabel) {
          swatchLabel.textContent = target.dataset.optionLabel;
        }
      }

      const variant = resolveVariant(step);
      if (variant) {
        showStepError(step, false);
        updateStepUi(step, variant);
      }
    });

    wizardHost.addEventListener('click', async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const nextBtn = target.closest('[data-compre-junto-wizard-next]');
      const backBtn = target.closest('[data-compre-junto-wizard-back]');
      const addBtn = target.closest('[data-compre-junto-wizard-add]');
      if (!nextBtn && !backBtn && !addBtn) return;

      const steps = getSteps(wizardHost);
      const currentIndex = parseInt(wizardHost.dataset.activeStep || '0', 10) || 0;
      const currentStep = steps[currentIndex];
      if (!currentStep) return;

      if (backBtn) {
        if (currentIndex > 0) setActiveStep(wizardHost, currentIndex - 1);
        return;
      }

      if (nextBtn) {
        if (!storeCurrentSelection(sectionRoot, currentStep)) return;
        if (currentIndex < steps.length - 1) setActiveStep(wizardHost, currentIndex + 1);
        return;
      }

      if (addBtn) {
        if (!storeCurrentSelection(sectionRoot, currentStep)) return;
        const items = collectAllSelections(sectionRoot, wizardHost);
        if (!items) {
          showStepError(currentStep, true);
          return;
        }
        await addItemsToCart(sectionRoot, items, addBtn);
      }
    });
  }

  function handleBuyClick(sectionRoot, button) {
    const opened = openWizard(sectionRoot);
    if (opened) return;

    // Fallback: sem wizard (sem produtos) — usa variantes dos cards
    const cards = sectionRoot.querySelectorAll('[data-compre-junto-card]');
    const items = [];
    cards.forEach((wrapper) => {
      const variantId = getSelectedVariantIdFromCard(wrapper);
      if (variantId) items.push({ id: Number(variantId), quantity: 1 });
    });
    if (!items.length) return;
    addItemsToCart(sectionRoot, items, button);
  }

  function getCarouselStep(track) {
    const slide = track.querySelector('[data-compre-junto-card], .jv-pc__slide');
    if (!slide) return track.clientWidth;
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function syncCarouselArrows(sectionRoot, track) {
    const prev = sectionRoot.querySelector('[data-jv-pc-prev]');
    const next = sectionRoot.querySelector('[data-jv-pc-next]');
    const arrows = sectionRoot.querySelector('[data-jv-pc-arrows]');
    if (!track) return;

    const max = track.scrollWidth - track.clientWidth;
    const needsScroll = max > 2;
    if (arrows) arrows.hidden = !needsScroll;
    if (prev) prev.disabled = !needsScroll || track.scrollLeft <= 1;
    if (next) next.disabled = !needsScroll || track.scrollLeft >= max - 1;
  }

  function bindCarousel(sectionRoot) {
    const track = sectionRoot.querySelector('[data-jv-pc-track]');
    if (!track || track.dataset.carouselBound === 'true') return;
    track.dataset.carouselBound = 'true';

    const prev = sectionRoot.querySelector('[data-jv-pc-prev]');
    const next = sectionRoot.querySelector('[data-jv-pc-next]');

    const scrollByDir = (direction) => {
      const step = getCarouselStep(track);
      if (step <= 0) return;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => scrollByDir(-1));
    if (next) next.addEventListener('click', () => scrollByDir(1));

    const onScrollOrResize = () => syncCarouselArrows(sectionRoot, track);
    track.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    if (typeof ResizeObserver === 'function') {
      const ro = new ResizeObserver(onScrollOrResize);
      ro.observe(track);
    }

    // Imagens / layout atrasam scrollWidth — revalidar após paint
    requestAnimationFrame(() => {
      syncCarouselArrows(sectionRoot, track);
      requestAnimationFrame(() => syncCarouselArrows(sectionRoot, track));
    });
    track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', onScrollOrResize, { once: true });
    });

    syncCarouselArrows(sectionRoot, track);
  }

  function initSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.compreJuntoInit === 'true') return;
    sectionRoot.dataset.compreJuntoInit = 'true';

    updateTotal(sectionRoot);
    setupVariantListeners(sectionRoot);
    bindWizard(sectionRoot);
    bindCarousel(sectionRoot);

    const button = sectionRoot.querySelector('[data-compre-junto-buy]');
    if (button) {
      button.setAttribute('aria-haspopup', 'dialog');
      button.addEventListener('click', () => handleBuyClick(sectionRoot, button));
    }
  }

  function init() {
    document.querySelectorAll('[data-compre-junto]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sectionRoot = e.target.querySelector('[data-compre-junto]');
    if (sectionRoot) {
      sectionRoot.dataset.compreJuntoInit = '';
      initSection(sectionRoot);
    }
  });

  const observer = new MutationObserver(() => {
    document.querySelectorAll('[data-compre-junto]:not([data-compre-junto-init])').forEach(initSection);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
